<form [formGroup]="form" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-stretch justify-start space-y-4">

    <app-selected class="w-full"
            [config]="dataSelected().at(0)"
            (selectValue)="handleValue($event)"
    ></app-selected>

    @for (item of dataInputs(); track $index) {
        <app-input class="w-full"
            [config]="item"
            [timeoutSeconds]="0.6"
            (submitValue)="handleValue($event)">
        </app-input>
    }

    @for (item of dataSelected().slice(1); track $index) {
        <app-selected class="w-full"
            [config]="item"
            (selectValue)="handleValue($event)"
        ></app-selected>
    }

    <app-autocomplete
      label="¿Cuál es tu profesión?"
      [items]="codpros"
      labelKey="label"
      valueKey="value"
      [defaultValue]="defaultData?.codpro"
      (valueChange)="form.patchValue({ codpro: $event })">
    </app-autocomplete>

</form>
